import { emptyChecks, type FinalLock, type ManualChecks, type Program, type Take } from './model';
import { evaluateTake, overallVerdict } from './preflight';

/** Viewing take details must never change the identity of a submission record. */
export function receiptSelection(program: Program, takes: Take[], locks: FinalLock[], manualChecks: Record<string, ManualChecks>) {
  const slots = (program.slots ?? [{ id: 'main', label: '보낼 영상', repertoireIds: [] }]).map(slot => {
    const lock = locks.find(item => item.programId === program.id && (item.slotId ?? 'main') === slot.id);
    const take = takes.find(item => item.programId === program.id && item.id === lock?.takeId && Boolean(item.hash) && item.hash === lock?.hash);
    const manual = manualChecks[slot.id === 'main' ? program.id : `${program.id}:${slot.id}`] ?? emptyChecks();
    const checks = take ? evaluateTake(program, take, lock, manual) : [];
    return { slot, take, lock: take ? lock : undefined, manual, checks, verdict: checks.length ? overallVerdict(checks) : 'check' as const };
  });
  const representative = slots.find(item => item.take);
  const verdict = slots.some(item => item.verdict === 'fail') ? 'fail' : slots.some(item => item.verdict === 'check') || !slots.length ? 'check' : 'pass';
  return { slots, representative, verdict } as const;
}
